import React from "react";
import { Link } from "@mui/material";
import { useNotebookPage, useNotebookPagePath } from "../../hook/page";

export const PageLink: React.FC<{
  pageId: string | undefined;
  "data-testid"?: string;
}> = ({ pageId, "data-testid": testId }) => {
  const { page } = useNotebookPage(pageId);
  const notebookPagePath = useNotebookPagePath();
  const name = (page?.["page-data"]?.name ?? "").trim();

  return (
    <Link
      href={notebookPagePath({ pageId })}
      underline="hover"
      color="text.primary"
      data-testid={testId}
      sx={{
        display: "flex",
        alignItems: "center",
        minHeight: "44px",
        wordBreak: "break-word",
      }}
    >
      {name === "" ? "Untitled" : name}
    </Link>
  );
};
